import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SolicitudViewModel } from '../datosbasicos/datosbasicos.types';
import { TracesValidationViewModel, ValidationInfoResponseViewModel } from '../../../core/_infrastructure/types/web.services';
import { AsyncInfoResponseViewModel } from '../../../core/components/asyncInfo/asyncInfo.types';
import { NumerosAutorizacionViewModel } from './envio.types';

///https://angular.io/tutorial/toh-pt6
//https://malcoded.com/posts/angular-backend-asp-core

@Injectable()
export class EnvioService {
    constructor(
        private http: HttpClient,
        @Inject('BASE_URL')
        private baseUrl: string,
    ) {}

    getLongTimeOutHeaders(): HttpHeaders {
        return new HttpHeaders({ timeout: `${300000}` });
    }

    validarSolicitud(id: number): Observable<string[]> {
        return this.http.get<string[]>(this.baseUrl + 'api/importacion/envio/' + id).pipe();
    }

    envioSolicitud(solicitud: SolicitudViewModel): Observable<SolicitudViewModel> {
        return this.http.put<SolicitudViewModel>(this.baseUrl + 'api/importacion/envio', solicitud).pipe();
    }

    sendV3OnDemand(id: number): Observable<any> {
        return this.http.get<any>(this.baseUrl + 'api/importacion/envio/SendAduanasV3OnDemand/' + id).pipe();
    }

    sendTracesOnDemand(id: number): Observable<TracesValidationViewModel> {
        return this.http
            .get<any>(this.baseUrl + 'api/importacion/envio/SendTracesOnDemand/' + id, {
                headers: this.getLongTimeOutHeaders(),
            })
            .pipe();
    }

    submit(id: number): Observable<AsyncInfoResponseViewModel> {
        return this.http
            .get<any>(this.baseUrl + 'api/importacion/envio/Submit/' + id, {
                headers: this.getLongTimeOutHeaders(),
            })
            .pipe();
    }

    getNumerosAutorizacion(id: number): Observable<NumerosAutorizacionViewModel[]> {
        return this.http.get<NumerosAutorizacionViewModel[]>(this.baseUrl + 'api/importacion/envio/getNumerosAutorizacion/' + id).pipe();
    }

    canSubmit(id: number): Observable<boolean> {
        return this.http.get<any>(this.baseUrl + 'api/importacion/envio/canSubmit/' + id).pipe();
    }

    resetTracesOnDemand(id: number): Observable<any> {
        return this.http.get<any>(this.baseUrl + 'api/importacion/envio/ResetTracesOnDemand/' + id).pipe();
    }

    ignoreTracesOnDemand(id: number): Observable<any> {
        return this.http.get<any>(this.baseUrl + 'api/importacion/envio/IgnoreTracesOnDemand/' + id).pipe();
    }

    resetV3OnDemand(id: number): Observable<any> {
        return this.http.get<any>(this.baseUrl + 'api/importacion/envio/ResetV3OnDemand/' + id).pipe();
    }

    validateOnDemand(id: number): Observable<ValidationInfoResponseViewModel[]> {
        return this.http
            .get<any>(this.baseUrl + 'api/importacion/envio/ValidateOnDemand/' + id, {
                headers: this.getLongTimeOutHeaders(),
            })
            .pipe();
    }
}
